import classNames from 'classnames';
import {useCartUI} from './CartUIProvider.client';
import CartIconWithItems from './CartIconWithItems.client';

/**
 * A client component that defines the behavior when a user toggles a cart
 */
export default function CartToggle() {
  const {isCartOpen, toggleCart} = useCartUI();

  return (
    <button
      className={classNames('rounded-full', 'bg-green-shopify', 'p-2')}
      type="button"
      data-testid="toggle-cart"
      aria-expanded={isCartOpen}
      aria-controls="cart"
      onClick={() => {
        toggleCart();
      }}
    >
      <CartIconWithItems />
      <span className="sr-only">Open cart</span>
    </button>
  );
}
